// extracted by mini-css-extract-plugin
module.exports = {"SectionRedWrapper":"sectionBox-module--SectionRedWrapper--3zajy","RedBody":"sectionBox-module--RedBody--DHqIx"};